/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S2_P1Inputs */

const en_guide_large_json_files_s2_p1 = /** @type {(inputs: Guide_Large_Json_Files_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you're sharing or uploading JSON files, <a href="/json-minifier">minify them first</a>. Removing whitespace and indentation typically reduces file size by 20-60%, depending on the original formatting. This saves bandwidth and upload time with no data loss.`)
};

const ko_guide_large_json_files_s2_p1 = /** @type {(inputs: Guide_Large_Json_Files_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 파일을 공유하거나 업로드하는 경우, <a href="/json-minifier">먼저 압축하세요</a>. 공백과 들여쓰기를 제거하면 원래 포맷에 따라 파일 크기가 일반적으로 20-60% 줄어듭니다. 데이터 손실 없이 대역폭과 업로드 시간을 절약할 수 있습니다.`)
};

const ja_guide_large_json_files_s2_p1 = /** @type {(inputs: Guide_Large_Json_Files_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONファイルを共有またはアップロードする場合は、まず<a href="/json-minifier">圧縮</a>してください。空白とインデントを削除すると、元のフォーマットに応じてファイルサイズが通常20〜60%縮小されます。データの損失なしに帯域幅とアップロード時間を節約できます。`)
};

/**
* | output |
* | --- |
* | "If you're sharing or uploading JSON files, <a href=\"/json-minifier\">minify them first</a>. Removing whitespace and indentation typically reduces file size by..." |
*
* @param {Guide_Large_Json_Files_S2_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s2_p1 = /** @type {((inputs?: Guide_Large_Json_Files_S2_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S2_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s2_p1(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s2_p1(inputs)
	return ja_guide_large_json_files_s2_p1(inputs)
});